// extracted by css-extract-rspack-plugin
export default {"ecomSpin":"ecomSpin-my2Thb"};